var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconGlobal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "6158f4dbfcc6d766686c4a0e_icon-global.svg",
    clipPath: "url(#clip0_13_488)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Page-1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-25"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Oval",
    d: "M23 45.9193C35.4264 45.9193 45.5 35.8457 45.5 23.4193C45.5 10.9929 35.4264 0.919312 23 0.919312C10.5736 0.919312 0.5 10.9929 0.5 23.4193C0.5 35.8457 10.5736 45.9193 23 45.9193Z",
    fill: "#2350F1"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path",
    d: "M33.6372 23.5558C33.6372 22.2213 31.0288 20.9354 27.251 20.3856C27.3576 21.4108 27.4116 22.4755 27.4116 23.5558C27.4116 24.6358 27.3576 25.7005 27.251 26.7257C31.0288 26.1759 33.6372 24.8908 33.6372 23.5558Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    d: "M19.8596 20.2787C19.7407 21.3391 19.6804 22.4403 19.6804 23.5558C19.6804 24.671 19.7407 25.7723 19.8596 26.8329C21.982 27.071 24.2906 27.071 26.4138 26.8329C26.533 25.7712 26.593 24.6699 26.593 23.5558C26.593 22.4414 26.5327 21.3399 26.4138 20.2787C24.2925 20.0409 21.9806 20.0409 19.8596 20.2787Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3",
    d: "M33.4818 21.7618C32.7301 17.3918 29.3008 13.9626 24.9307 13.2109C25.9578 14.4142 26.7607 16.6792 27.1504 19.542C30.0129 19.9312 32.2779 20.7341 33.4818 21.7618Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4",
    d: "M26.3069 19.4417C25.7571 15.6642 24.472 13.0558 23.137 13.0558C21.8023 13.0558 20.5166 15.6641 19.9668 19.442C22.0125 19.2287 24.2576 19.229 26.3069 19.4417Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5",
    d: "M19.9668 27.6696C20.5166 31.4474 21.8023 34.0557 23.137 34.0557C24.472 34.0557 25.7571 31.4474 26.3069 27.6696C24.2563 27.8826 22.0169 27.8826 19.9668 27.6696Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6",
    d: "M12.792 25.3497C13.5436 29.7196 16.9729 33.1492 21.3428 33.9008C20.3152 32.697 19.5123 30.432 19.1231 27.5695C16.2605 27.1797 13.9955 26.3768 12.792 25.3497Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7",
    d: "M24.9307 33.9008C29.3006 33.1492 32.7301 29.7199 33.4818 25.3497C32.2785 26.3768 30.0129 27.1797 27.1504 27.5695C26.7607 30.432 25.9578 32.6975 24.9307 33.9008Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8",
    d: "M19.0224 26.7257C18.916 25.7024 18.862 24.638 18.862 23.5558C18.862 22.4755 18.916 21.4108 19.0226 20.3856C15.2448 20.9354 12.6367 22.2211 12.6367 23.5558C12.6367 24.8908 15.2448 26.1759 19.0224 26.7257Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9",
    d: "M21.3428 13.2112C16.9726 13.9625 13.5436 17.3915 12.792 21.762C13.9953 20.7344 16.2603 19.9315 19.1231 19.5423C19.5123 16.6795 20.3152 14.4145 21.3428 13.2112Z",
    fill: "white"
  })))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_13_488"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 45,
    height: 45,
    fill: "white",
    transform: "translate(0.5 0.919312)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconGlobal);
export default __webpack_public_path__ + "static/media/icon-global.9f9b87971e10a0f454dedf0083d83579.svg";
export { ForwardRef as ReactComponent };